// extracted by mini-css-extract-plugin
export default {"mark":"mark_SideMark-module_22D2N"};